import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartMixed } from "@fortawesome/pro-solid-svg-icons";
import {
  faGrid2,
  faBuildingUser,
  faFileCertificate,
  faUsers,
  faMoneyCheck,
  faGear,
  faNoteMedical,
  faHourglass,
  faSquareExclamation,
  faScrewdriverWrench,
  faUserPolice,
  faFiles,
  faMoneyCheckPen,
  faFileChartColumn,
  faCalendar,
  faForklift,
  faPalletBoxes,
  faWarehouseFull,
  faSensor,
  faFile,
  faListCheck,
} from "@fortawesome/pro-regular-svg-icons";
import { ROLES } from "./constant";

export interface itemProp {
  id: number;
  title: string;
  path: string;
  access_role: ROLES[];
  icon: any;
  child: itemProp[];
  classname: string;
  urlCommonWord?: string;
}

var company_id;
const role_id = localStorage.getItem("_role_id");

if (role_id) {
  if (role_id === "11" || role_id === "9") {
    company_id = localStorage.getItem("_tpi_firm_id");
  } else {
    company_id = localStorage.getItem("_warehouse_id");
  }
}


export const navbarList: itemProp[] = [
  {
    id: 1,
    title: "Dashboard",
    path: "/dashboard",
    access_role: [
      ROLES.SUPERADMIN,
      ROLES.SUBADMIN,
      ROLES.WAREHOUSEADMIN,
      ROLES.WAREHOUSEOWNER,
      ROLES.PRSES,
      ROLES.TPIMANAGER,
      ROLES.TPIOWNER,
      ROLES.MANAGEMENTUSER
    ],
    icon: <FontAwesomeIcon icon={faGrid2} />,
    child: [],
    classname: "dashboard",
    urlCommonWord: "dashboard"
  },
  {
    id: 2,
    title: "Rack Health",
    path: "/rack-health",
    access_role: [ROLES.PRSES, ROLES.WAREHOUSEADMIN],
    icon: <FontAwesomeIcon icon={faNoteMedical} />,
    child: [],
    classname: "rackhealth",
    urlCommonWord: "rack-health"
  },
  {
    id: 6,
    title: "Pallet Management",
    path: "/pallet-management",
    access_role: [ROLES.PRSES, ROLES.WAREHOUSEADMIN],
    icon: <FontAwesomeIcon icon={faPalletBoxes} />,
    child: [],
    classname: "palletmanagement",
    urlCommonWord: "pallet"
  },
  {
    id: 16,
    title: "MHE Management",
    path: "/mhe-management",
    access_role: [ROLES.PRSES, ROLES.WAREHOUSEADMIN],
    icon: <FontAwesomeIcon icon={faForklift} />,
    classname: "mhe",
    urlCommonWord: "mhe",
    child: [
      {
        id: 1,
        child: [],
        title: "MHE Monitor",
        path: "/mhe-movement-tracking",
        access_role: [ROLES.PRSES, ROLES.WAREHOUSEADMIN],
        icon: <FontAwesomeIcon icon={faChartMixed} />,
        classname: "mhemonitor",
        urlCommonWord: "movement",
      },
      {
        id: 2,
        child: [],
        title: "MHE Overview",
        path: "/mhe-overview",
        access_role: [ROLES.PRSES, ROLES.WAREHOUSEADMIN],
        icon: <FontAwesomeIcon icon={faChartMixed} />,
        classname: "mheoverview",
        urlCommonWord: "mhe-overview",
      },
      {
        id: 3,
        child: [],
        title: "MHE Summary",
        path: "/mhe-sensor-summary",
        access_role: [ROLES.PRSES, ROLES.WAREHOUSEADMIN],
        icon: <FontAwesomeIcon icon={faChartMixed} />,
        classname: "mhesummary",
        urlCommonWord: "mhe-sensor",
      },
      {
        id: 4,
        child: [],
        title: "Operator Summary",
        path: "/mhe-operator-summary",
        access_role: [ROLES.PRSES, ROLES.WAREHOUSEADMIN],
        icon: <FontAwesomeIcon icon={faChartMixed} />,
        classname: "operatorsummary",
        urlCommonWord: "operator",
      },
      {
        id: 5,
        child: [],
        title: "MHE Setting",
        path: "/mhe-setting",
        access_role: [ROLES.PRSES, ROLES.WAREHOUSEADMIN],
        icon: <FontAwesomeIcon icon={faChartMixed} />,
        classname: "mhesetting",
        urlCommonWord: "mhe-setting",
      },
    ],
  },
  {
    id: 3,
    title: "User Summary",
    path: "/user-summary",
    access_role: [
      ROLES.WAREHOUSEADMIN,
      ROLES.WAREHOUSEOWNER,
      ROLES.PRSES,
      ROLES.SUPERADMIN,
      ROLES.TPIMANAGER,
      ROLES.TPIOWNER
    ],
    icon: <FontAwesomeIcon icon={faUsers} />,
    child: [],
    classname: "usersummary",
    urlCommonWord: "user"
  },
  {
    id: 4,
    title: "Licence Management",
    path: "/licence-management",
    access_role: [ROLES.SUPERADMIN, ROLES.SUBADMIN, ROLES.TPIMANAGER, ROLES.TPIOWNER],
    icon: <FontAwesomeIcon icon={faFileCertificate} />,
    classname: "licence",    
    child: [
      {
        id: 1,
        child: [],
        title: "Warehouse licence",
        path: "/licence-summary",
        access_role: [ROLES.SUPERADMIN, ROLES.SUBADMIN, ROLES.TPIMANAGER, ROLES.TPIOWNER],
        icon: <FontAwesomeIcon icon={faChartMixed} />,
        classname: "warehouselicencesummary",
        urlCommonWord:"licence",
      },
    ],
  },
  {
    id: 5,
    title: "Company Summary",
    path: "/company-summary",
    access_role: [ROLES.SUPERADMIN, ROLES.SUBADMIN],
    child: [],
    icon: <FontAwesomeIcon icon={faBuildingUser} />,
    classname: "companysummary",
    urlCommonWord: "company"
  },
  {
    id: 6,
    title: "Company Details",
    path: `/edit-company`,
    access_role: [ROLES.TPIOWNER, ROLES.WAREHOUSEADMIN],
    child: [],
    icon: <FontAwesomeIcon icon={faBuildingUser} />,
    classname: "companysummary",
    urlCommonWord: "company"
  },
  {
    id: 7,
    title: "Coupon Summary",
    path: "/coupon-summary",
    access_role: [ROLES.SUPERADMIN, ROLES.SUBADMIN],
    child: [],
    icon: <FontAwesomeIcon icon={faMoneyCheck} />,
    classname: "couponsummary",
    urlCommonWord: "coupon"
  },
  {
    id: 15,
    title: "Inspection Schedule",
    path: "/inspection-schedule-calender",
    access_role: [ROLES.PRSES, ROLES.WAREHOUSEADMIN],
    icon: <FontAwesomeIcon icon={faCalendar} />,
    child: [],
    classname: "inspectionschedule",
    urlCommonWord: "schedule"
  },
  {
    id: 17,
    title: "Inspection Summary",
    path: "/complete-inspection",
    access_role: [ROLES.PRSES, ROLES.WAREHOUSEADMIN],
    icon: <FontAwesomeIcon icon={faHourglass} />,
    child: [],
    classname: "inspectionsummary",
    urlCommonWord: "complete-inspection"
  },
  {
    id: 18,
    title: "Reported Issues",
    path: "/reported-issue-summary",
    access_role: [ROLES.PRSES, ROLES.WAREHOUSEADMIN],
    icon: <FontAwesomeIcon icon={faSquareExclamation} />,
    child: [],
    classname: "reportedissues",
    urlCommonWord: "reported-issue"
  },
  {
    id: 24,
    title: "Quotation Summary",
    path: "/quotation-summary",
    access_role: [ROLES.SUPERADMIN, ROLES.SUBADMIN],
    icon: <FontAwesomeIcon icon={faMoneyCheckPen} />,
    child: [],
    classname: "quotationsummary",
    urlCommonWord: "quotation"
  },
  {
    id: 25,
    title: "Projects",
    path: "/projects",
    access_role: [ROLES.TPIMANAGER, ROLES.TPIOWNER],
    icon: <FontAwesomeIcon icon={faFileChartColumn} />,
    child: [],
    classname: "projects",
    urlCommonWord: "project"
  },
  {
    id: 27,
    title: "Maintenance",
    path: "/maintenance",
    access_role: [ROLES.PRSES, ROLES.WAREHOUSEADMIN],
    icon: <FontAwesomeIcon icon={faScrewdriverWrench} />,
    child: [
      {
        id: 1,
        title: "Verified Issues",
        path: "/verified-issue-summary",
        access_role: [ROLES.PRSES, ROLES.WAREHOUSEADMIN],
        icon: <FontAwesomeIcon icon={faScrewdriverWrench} />,
        child: [],
        classname: "verifiedissues",
        urlCommonWord: "verified-issue"
      },
    ],
    classname: "projects",
  },
  {
    id: 28,
    child: [],
    title: "TPI Inspection Summary",
    path: "/tpi-inspection-summary",
    access_role: [ROLES.PRSES, ROLES.WAREHOUSEADMIN],
    icon: <FontAwesomeIcon icon={faChartMixed} />,
    classname: "inspectionsummary",
    urlCommonWord: "tpi-inspection"
  },
  {
    id: 29,
    title: "Master List",
    path: "/master-list",
    access_role: [ROLES.PRSES, ROLES.SUPERADMIN, ROLES.TPIOWNER, ROLES.WAREHOUSEADMIN],
    icon: <FontAwesomeIcon icon={faFiles} />,
    classname: "masterlist",
    child: [
      {
        id: 1,
        child: [],
        title: "Element Summary",
        path: "/element-summary",
        access_role: [ROLES.PRSES, ROLES.TPIOWNER, ROLES.WAREHOUSEADMIN],
        icon: <FontAwesomeIcon icon={faChartMixed} />,
        classname: "masterelementsummary",
        urlCommonWord: "element-summary"
      },
      {
        id: 2,
        child: [],
        title: "Element Summary",
        path: "/element-summary-master",
        access_role: [ROLES.SUPERADMIN],
        icon: <FontAwesomeIcon icon={faChartMixed} />,
        classname: "masterelementsummary",
      },
      {
        id: 3,
        child: [],
        title: "Element Stock Insights",
        path: "/element-stock-insights",
        access_role: [ROLES.PRSES, ROLES.WAREHOUSEADMIN],
        icon: <FontAwesomeIcon icon={faChartMixed} />,
        classname: "masterelementsummary",
        urlCommonWord: "stock"
      },
      {
        id: 4,
        child: [],
        title: "Element Library",
        path: "/element-library",
        access_role: [ROLES.TPIOWNER, ROLES.TPIMANAGER, ROLES.PRSES, ROLES.SUPERADMIN, ROLES.WAREHOUSEADMIN],
        icon: <FontAwesomeIcon icon={faChartMixed} />,
        classname: "masterelementsummary",
        urlCommonWord: "element-library"
      },
      {
        id: 5,
        child: [],
        title: "Rack Type Assignment",
        path: "/rack-type-assignment",
        access_role: [ROLES.TPIOWNER, ROLES.TPIMANAGER, ROLES.PRSES, ROLES.WAREHOUSEADMIN],
        icon: <FontAwesomeIcon icon={faChartMixed} />,
        classname: "racktypeassignment",
        urlCommonWord: "rack-type-assignment"
      },
      
    ],
  },
  {
    id: 30,
    title: "Subscription",
    path: "/subscription",
    access_role: [ROLES.SUPERADMIN, ROLES.TPIOWNER],
    icon: <FontAwesomeIcon icon={faMoneyCheck} />,
    classname: "subscription",
    child: [
      {
        id: 1,
        child: [],
        title: "Overview",
        path: "/subscription-overview",
        access_role: [ROLES.TPIMANAGER, ROLES.TPIOWNER],
        icon: <FontAwesomeIcon icon={faChartMixed} />,
        classname: "subscriptionoverview",
        urlCommonWord: "overview"
      },
      {
        id: 3,
        child: [],
        title: "Subscription Summary",
        path: "/subscription-summary",
        access_role: [ROLES.SUPERADMIN],
        icon: <FontAwesomeIcon icon={faChartMixed} />,
        classname: "packagesummary",
        urlCommonWord: "subscription"
      },
    ],
  },
  {
    id: 31,
    title: "Settings",
    path: "/settings",
    access_role: [ROLES.PRSES],
    icon: <FontAwesomeIcon icon={faGear} />,
    child: [],
    classname: "settings",
    urlCommonWord: "setting"
  },
  {
    id: 32,
    title: "Settings",
    path: "/settings1",
    access_role: [ROLES.WAREHOUSEADMIN],
    icon: <FontAwesomeIcon icon={faGear} />,
    child: [
      {
        id: 1,
        title: "Settings",
        path: "/settings",
        access_role: [ROLES.WAREHOUSEADMIN],
        icon: <FontAwesomeIcon icon={faGear} />,
        child: [],
        classname: "settings",
        urlCommonWord: "settings"
      },
      {
        id: 2,
        title: "Escalation Matrix",
        path: "/escalation-matrix",
        access_role: [ROLES.WAREHOUSEADMIN],
        icon: <FontAwesomeIcon icon={faGear} />,
        child: [],
        classname: "escalation",
        urlCommonWord: "escalation"
      },
      {
        id: 3,
        title: "Digitization Data Settings",
        path: "/digitization-data-setting",
        access_role: [ROLES.WAREHOUSEADMIN],
        icon: <FontAwesomeIcon icon={faGear} />,
        child: [],
        classname: "emailnotification",
        urlCommonWord: "digitization-data-setting"
      }
    ],
    classname: "settings",
    urlCommonWord: "email-notification"
  },
  {
    id: 33,
    title: "Warehouse Summary",
    path: "/assigned-warehouse",
    access_role: [ROLES.MANAGEMENTUSER],
    icon: <FontAwesomeIcon icon={faWarehouseFull} />,
    child: [],
    classname: "assignedwarehouse",
    urlCommonWord: "assigned"
  },
  {
    id: 34,
    title: "Sensor Inventory",
    path: "/sensor-inventory",
    access_role: [ROLES.SUPERADMIN, ROLES.SUBADMIN],
    icon: <FontAwesomeIcon icon={faSensor} />,
    child: [],
    classname: "sensor",
    urlCommonWord: "sensor"
  },
  {
    id: 35,
    title: "File Manager",
    path: "/file-manager",
    access_role: [ROLES.PRSES, ROLES.WAREHOUSEADMIN],
    icon: <FontAwesomeIcon icon={faFile} />,
    child: [],
    classname: "fileManager",
    urlCommonWord: "fileManager"
  },
  {
    id: 36,
    title: "Task Overview",
    path: "/task-overview",
    access_role: [ROLES.PRSES, ROLES.WAREHOUSEADMIN],
    icon: <FontAwesomeIcon icon={faListCheck} />,
    child: [],
    classname: "task-overview",
    urlCommonWord: "task-overview"
  },
  {
    id: 37,
    title: "TPI Company",
    path: "/tpi-company-list",
    access_role: [ROLES.SUPERADMIN],
    icon: <FontAwesomeIcon icon={faListCheck} />,
    child: [],
    classname: "tpi-company",
    urlCommonWord: "tpi-company"
  },
];
